/**
 * Base paths for the app
 */
export const BASE_APP_PATHS = {
    OrganizationHub: '/',
    Inbox: '/inbox',
    TeamInbox: '/team-inbox',
    MeetingsBooked: '/meetings-booked',
    Outbox: '/outbox',
    Campaign: '/campaign',
    AllCampaigns: '/allcampaigns',
    Sent: '/sent',
    Connections: '/connections',
    Settings: '/settings',
    AdminHub: '/adminhub',
    CreateCampaign: '/campaign/create',
    Referral: '/referral',
    Billing: '/billing',
} as const;
